<template>
  <li class="bg-gray-100 rounded-2xl pt-4 px-6 pb-6 flex flex-col gap-y-3 h-full relative">
    <h3
      class="heading-xs lg:heading-sm"
      v-text="result.title"
    />

    <dl class="flex flex-col gap-y-1 body-md mb-4">
      <div class="flex gap-x-2 items-center">
        <dt class="text-primary-500">
          <span class="sr-only">Date:</span>
          <IconCalendar
            :size="24"
            aria-hidden="true"
          />
        </dt>
       <dd v-text="`${result.start_date_display ?? formatDate(result.start_date)} - ${result.end_date_display ?? formatDate(result.end_date)}`" />
      </div>

      <div class="flex gap-x-2 items-center">
        <dt class="text-primary-500">
          <span class="sr-only">Time:</span>
          <IconClock
            :size="24"
            aria-hidden="true"
          />
        </dt>
        <dd v-text="`${result.start_time ?? ''} - ${result.end_time ?? ''} ${result.time_zone ?? ''}`" />
      </div>

      <div class="flex gap-x-2 items-center">
        <dt class="text-primary-500">
          <span class="sr-only">Location:</span>
          <IconMapPin
            :size="24"
            aria-hidden="true"
          />
        </dt>
        <dd v-text="result.location" />
      </div>
    </dl>

    <a
      :href="`${env.BASE_URL}/${result.uri}`"
      class="btn btn--outline mt-auto"
    >
      <span v-text="'View Details'" />
      <span
        class="sr-only"
        v-text="` about ${result.title}`"
      />
    </a>

    <span
      v-if="result.registration_closed === 'true'"
      class="absolute -top-2.5 left-4 text-xs font-semibold bg-red text-white px-3 py-1 rounded-2xl"
      v-text="'Sold Out'"
    />
  </li>
</template>

<script lang="ts" setup>
import { format } from 'date-fns'
import { IconCalendar, IconClock, IconMapPin } from '@tabler/icons-vue'

import { env } from '@js/utils/env'

import { AisHit } from '@js/types/search/AisHit'

defineOptions({
  name: 'CourseSearchResult',
})

defineProps<{
  result: AisHit
}>()

const formatDate = (date: number): string => {
  return format(new Date(date * 1000), 'E. MM/dd')
}

const formatTime = (time: number): string => {
  return format(new Date(time * 1000), 'h:mm a')
}
</script>
